module.exports = __webpack_public_path__ + "static/media/home-cover.676285cc.svg";